import { render, staticRenderFns } from "./CorportativoIngresosPorAnio.vue?vue&type=template&id=7a70d1cf"
import script from "./CorportativoIngresosPorAnio.vue?vue&type=script&lang=js"
export * from "./CorportativoIngresosPorAnio.vue?vue&type=script&lang=js"
import style0 from "./CorportativoIngresosPorAnio.vue?vue&type=style&index=0&id=7a70d1cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports